import { IMG_PATH } from "../../constants/paths"

const LeafImage = ({ side, num, style }) => {

    return (
        <img className={`leaf-bg leaf-bg__${side} leaf-bg__${side}--${num} `} src={`${IMG_PATH}design/leaves/leaf-${num}.png`} style={{ [side]: 0, ...style }} />
    )
}

export default LeafImage